import { ButtonList } from '@versita/frontend/campus-ui-web';
import { usePublish } from '../../hooks/usePublish';
import { useTimetableManagerState } from '../../state';
import { toast } from 'react-hot-toast';

export const AdminTableActions = ({
  flavour,
}: {
  flavour: 'STUDENT' | 'COURSE';
}) => {
  const { selectedIds, filteredItems, academicYear } =
    useTimetableManagerState();
  const { updateSelectedItems } = usePublish(academicYear, flavour);

  const getItemsToConsider = () => {
    if (selectedIds.length > 0) {
      return filteredItems.filter((item) => selectedIds.includes(item.id));
    }
    return [];
  };
  const canPublishAll = (items: typeof filteredItems) => {
    return items.every((item) => !item.willNotPublish && !item.published);
  };

  const canUnpublishAll = (items: typeof filteredItems) => {
    return items.every((item) => item.published);
  };

  const canLockAll = (items: typeof filteredItems) => {
    return items.every((item) => !item.willNotPublish);
  };

  const canUnlockAll = (items: typeof filteredItems) => {
    return items.every((item) => item.willNotPublish);
  };

  const itemsToConsider = getItemsToConsider();

  const canPublish = canPublishAll(itemsToConsider);
  const canUnpublish = canUnpublishAll(itemsToConsider);
  const canLock = canLockAll(itemsToConsider);
  const canUnlock = canUnlockAll(itemsToConsider);

  const publishActions = [
    { label: 'Disable selected', value: 'willNotPublish', enabled: canLock },
    { label: 'Enable selected', value: 'willNotPublish', enabled: canUnlock },
    { label: 'Publish selected', value: 'published', enabled: canPublish },
    {
      label: 'Unpublish selected',
      value: 'unpublished',
      enabled: canUnpublish,
    },
  ];

  function handleSelectItems(value: string) {
    const published = value === 'published';
    const willNotPublish = value === 'willNotPublish';

    toast.promise(
      updateSelectedItems(
        filteredItems,
        selectedIds,
        published,
        willNotPublish,
      ),
      {
        loading: 'Updating items...',
        success: 'Timetables updated',
        error: 'Update failed',
      },
    );
  }

  return (
    <div role="region" aria-label="Action Buttons">
      <ButtonList
        buttonItems={publishActions}
        description="Bulk Actions"
        handleClick={handleSelectItems}
      />
    </div>
  );
};
